import { ApiUtil } from '@/shared/api';

// 과제 학생
export const evalStntApi = {
    /**
     * 과제 시작하기 ( /stnt/eval )
     */
    postEvalStart: (param: API.STNT.EvalStart.Req) => {
        return ApiUtil._post<API.STNT.EvalStart.Res>('/stnt/eval', param);
    },
    /**
     * 과제 정보 조회 ( /stnt/eval/info )
     */
    getStEvalInfo: (param: API.STNT.EvalInfo.Req) => {
        if (param.evlId != 0 && param.userId != '')
            return ApiUtil.get<API.STNT.EvalInfo.Res>('/stnt/eval/info', param);
    },

    /**
     * 평가 결과 조회 ( /stnt/eval/result )
     */
    getStEvalResult: (param: API.STNT.EvalResult.Req, isLoading?: boolean) => {
        return ApiUtil.get<API.STNT.EvalResult.Res>('/stnt/eval/result', param, isLoading);
    },

    /**
     * (학생)응시(article) 재확인 횟수 저장  ( /stnt/eval/recheck )
     */
    postStEvalRecheck: (param: API.STNT.EvalRecheck.Req, isLoading?: boolean) => {
        return ApiUtil.post<API.STNT.EvalRecheck.Res>('/stnt/eval/recheck', param, isLoading);
    },

    /**
     * 학생)응시(article)자동저장 ( /stnt/eval/save )
     */
    postStEvalSave: (param: API.STNT.EvalSave.Req, isLoading?: boolean) => {
        return ApiUtil.post<API.STNT.EvalSave.Res>('/stnt/eval/save', param, isLoading);
    },

    /**
     * (학생)평가 자료 제출하기 ( /stnt/eval/submit )
     */
    postStEvalSubmit: (param: API.STNT.EvalSubmit.Req, isLoading?: boolean) => {
        return ApiUtil.post<API.STNT.EvalSubmit.Res>('/stnt/eval/submit', param, isLoading);
    },

    /**
     * 평가 정보 수정(시작하기) ( /tch/eval/start )
     */
    postStntEvaluationStart: (param: API.STNT.EvalStart.Req) => {
        return ApiUtil._post<API.STNT.EvalStart.Res>('/stnt/eval/start', param);
    },

    /* (선생)평가 정보 조회 ( /tch/eval/info ) */
    getEvalInfoTch: (param: API.STNT.EvalInfoTch.Req) => {
        return ApiUtil.get<API.STNT.EvalInfoTch.Res>('/tch/eval/info', param);
    },

    /* (선생)평가 종료하기 ( /tch/eval/end ) */
    postEvalEndTch: (param: API.TCH.EvalEnd.Req) => {
        return ApiUtil.post<API.TCH.EvalEnd.Res>('/tch/eval/end', param);
    },

    /**
     * 평가 또는 과제 수행시 학생의 진입 또는 재진입 여부 확인
     */
    getEvalStntTrgtDone: (param: API.STNT.StntTrgtDone.Req) => {
        return ApiUtil.post<API.STNT.StntTrgtDone.Res>('/stnt/trgt/done', param);
    },

    /**
     * 평가 타이머 조회  ( /stnt/eval/time/usage )
     */
    getEvalTimeUsage: (param: API.STNT.TimeUsage.Req) => {
        return ApiUtil.get<API.STNT.TimeUsage.Res>('/stnt/eval/time/usage', param);
    },

    /**
     * 평가 타이머 저장  ( /stnt/eval/time/usage )
     */
    postSaveEvalTimeUsage: (param: API.STNT.SaveTimeUsage.Req) => {
        return ApiUtil.post<API.STNT.SaveTimeUsage.Res>('/stnt/eval/time/usage', param);
    },

    /**
     * 손글씨 조회 (/{tch|stnt}/eval/mdul/hdwrt/view)
     */
    getStntEvalMdulHdwrtView: (param: API.STNT.EvalMdulHdwrtView.Req, isLoading?: boolean) => {
        return ApiUtil._get<API.STNT.EvalMdulHdwrtView.Res>('/stnt/eval/mdul/hdwrt/view', param);
    },

    /**
     * 손글씨 저장 (/{tch|stnt}/eval/mdul/hdwrt/save)
     */
    postStntEvalMdulHdwrtSave: (param: API.STNT.EvalMdulHdwrtSave.Req, isLoading?: boolean) => {
        return ApiUtil._post<API.STNT.EvalMdulHdwrtSave.Res>('/stnt/eval/mdul/hdwrt/save', param);
    },
};
